import isPaymentLink from './isPaymentLink'

const canCreateTransaction = (company, user) => !isPaymentLink(company)
  && user?.permission !== 'read_only'
export default canCreateTransaction
